/**
 * A link into one policy: /app?app=ppm&policy=<id>. Readiness sends people
 * here from "Open the policy" on a matched policy line; the command center
 * (compliance) and the reading room (everyone else) both honor it and land
 * on that policy, not on the library.
 *
 * The parameter is removed from the address as soon as it is read, so
 * Back, a sidebar change, or a reload never re-opens it. Only a UUID is
 * accepted; anything else is ignored.
 */
export function takePolicyParam() {
  try {
    const url = new URL(window.location.href);
    const id = url.searchParams.get('policy');
    if (!id) return null;
    url.searchParams.delete('policy');
    window.history.replaceState({}, '', url.toString());
    return /^[0-9a-f-]{36}$/i.test(id) ? id : null;
  } catch { return null; }
}

export default takePolicyParam;
